import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import LeadCard from "@/components/feature/LeadCard";
import { leads } from "@/mocks/leads";

export default function FeaturedLeads() {
  const [featured, ...rest] = leads;
  const sideList = rest.slice(0, 3);

  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-100 border-y border-background-200" aria-labelledby="featured-title">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          id="featured-title"
          eyebrow="精选线索"
          title="读者送来的线索，正在被认真对待"
          desc="以下是已经完成初步核实、并整理成文的线索。所有个人信息均已做匿名化处理。"
        />

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-6">
          <article className="lg:col-span-7 group rounded-lg overflow-hidden bg-background-50 border border-background-200 flex flex-col">
            <Link
              to={`/leads/${featured.id}`}
              className="block w-full h-56 md:h-72 overflow-hidden bg-background-200 cursor-pointer"
              aria-label={featured.title}
            >
              <img
                src={featured.cover}
                alt={`${featured.title} - ${featured.category}线索配图`}
                className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-500"
              />
            </Link>
            <div className="p-5 md:p-6">
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-xs px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 font-label">
                  本期重点
                </span>
                <span className="text-xs px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 font-label">
                  {featured.category}
                </span>
              </div>
              <h3 className="mt-3 font-heading text-xl md:text-2xl font-bold text-foreground-950 leading-snug">
                <Link to={`/leads/${featured.id}`} className="hover:text-primary-600 transition-colors cursor-pointer">
                  {featured.title}
                </Link>
              </h3>
              <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed line-clamp-3">
                {featured.summary}
              </p>
              <div className="mt-4 flex flex-wrap items-center gap-4 text-xs text-foreground-500 font-label">
                <span>{featured.date}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-time-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
                  {featured.readTime}
                </span>
              </div>
            </div>
          </article>

          <ul className="lg:col-span-5 flex flex-col gap-6">
            {sideList.map((lead) => (
              <li key={lead.id} className="flex-1 flex">
                <LeadCard lead={lead} variant="wide" />
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/leads"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-foreground-300 text-foreground-900 text-sm font-label font-medium whitespace-nowrap hover:bg-foreground-950 hover:text-background-50 transition-colors cursor-pointer"
          >
            进入爆料线索库
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}